import { useState } from 'react';
import {
  KrBacktestRequest,
  KrBacktestSummary,
  runKrBacktest,
} from '../services/krBacktestApi';
import {
  importTossKrHoldings,
} from '../services/marketWatchlistApi';

export function useKrBacktest() {
  const [symbols, setSymbols] = useState('005930,000660');
  const [startDate, setStartDate] = useState('2025-08-21');
  const [endDate, setEndDate] = useState('2026-06-18');
  const [initialCash, setInitialCash] = useState('10000000');
  const [strategyProfile, setStrategyProfile] = useState('kr_paper');
  const [result, setResult] = useState<KrBacktestSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const [watchlistLoading, setWatchlistLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);

  async function run() {
    await runWithSymbols(currentSymbols());
  }

  async function runCurrentWatchlist() {
    setWatchlistLoading(true);
    setError(null);
    setNotice(null);
    try {
      setResult(await runKrBacktest(buildWatchlistRequest()));
      setNotice('현재 KR watchlist 기준으로 백테스트를 실행했습니다');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'KR 백테스트 실행 실패');
    } finally {
      setWatchlistLoading(false);
    }
  }

  async function importHoldings() {
    setWatchlistLoading(true);
    setError(null);
    try {
      const watchlist = await importTossKrHoldings();
      setSymbols(watchlist.tickers.join(','));
      setNotice(`Toss KR 보유종목 ${watchlist.count}개를 watchlist seed로 저장했습니다`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Toss 보유종목 import 실패');
    } finally {
      setWatchlistLoading(false);
    }
  }

  async function runWithSymbols(nextSymbols: string[]) {
    setLoading(true);
    setError(null);
    setNotice(null);
    try {
      setResult(await runKrBacktest(buildRequest(nextSymbols)));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'KR 백테스트 실행 실패');
    } finally {
      setLoading(false);
    }
  }

  function buildRequest(nextSymbols: string[]): KrBacktestRequest {
    return {
      symbols: nextSymbols,
      symbol_source: 'manual',
      start_date: startDate,
      end_date: endDate,
      initial_cash: initialCash,
      strategy_profile: strategyProfile,
      bar_limit: 200,
      position_size_percent: 0.1,
    };
  }

  function buildWatchlistRequest(): KrBacktestRequest {
    return { ...buildRequest([]), symbol_source: 'kr_watchlist' };
  }

  function currentSymbols() {
    return symbols.split(',').map((item) => item.trim()).filter(Boolean);
  }

  return {
    symbols, setSymbols, startDate, setStartDate, endDate, setEndDate,
    initialCash, setInitialCash, strategyProfile, setStrategyProfile,
    result, loading, watchlistLoading,
    error, notice, run, runCurrentWatchlist, importHoldings,
  };
}
